<template>
  <div
    v-if="isAdmin && isPromoteur"
    class="l-contentmain contentmain">
    <page-nav-bar
      v-if="canal"
      :is-sticky="true"
      :back-button="true"
      :has-actions="!canal.protected">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'ChannelListVue' }">
            Canal
          </router-link>
        </h1>

        <div class="page-header-breadcrumb-separator"></div>
        <div
          class="page-header-breadcrumb-item"
          v-if="canal && canal.name">
          <span class="has-text-weight-normal has-text-grey-dark">{{ canal.name }}</span>
        </div>
      </template>
      <a
        v-if="!canal.protected"
        slot="dropdown-content"
        class="dropdown-item has-background-danger has-text-white"
        @click="removeCanal">
        <span class="icon is-medium"><i class="fas fa-trash-alt"></i></span><span class="is-margin-left-xsmall">Supprimer</span>
      </a>
    </page-nav-bar>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-content
      v-else-if="canal && !loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="true"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <div class="has-background-white is-border">
          <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
            <figure class="image is-128x128 is-margin-auto has-vadPicto has-picto--top2Right">
              <div class="is-border is-border--circle is-clipped">
                <div
                  class="has-text-white is-clipped is-size-1 is-relative has-background-light--darken2"
                  style="width: 126px; height: 126px; line-height: 126px;">
                  <i class="is-absolutecenter far fa-users-cog fa-2x"></i>
                </div>
              </div>
            </figure>
            <div
              v-if="canal && canal.name"
              class="title is-3 is-margin-top-xsmall is-marginless-bottom">
              <b>{{ canal.name }}</b>
            </div>
          </div>
          <div class="is-border-top is-border--dashed">
            <div class="columns is-multiline is-gapless">
              <div
                @click="tab === 'MEMBRES'"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Membre(s) du  canal
                </div>
                <div> {{ canal.accounts_in_sales.length }} </div>
              </div>
              <div
                v-if="total_mandats > 0"
                @click="tab === 'MEMBRES'"
                class="column is-6 is-border-bottom is-border-right is-border--dashed columns is-column is-space-between is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
                <div class="has-text-grey is-size-6">
                  Mandat(s) du  canal
                </div>
                <div> {{ total_mandats }} </div>
              </div>
            </div>
          </div>
        </div>
        <event-tracker-list :field="'canal'"></event-tracker-list>
      </template>
      <div class="has-background-white is-border">
        <tabs
          :links="canalTabLinks"
          :current-tab="tab"
          @changeView="tab = $event"
          mode="emitter"
          class="is-border-bottom"></tabs>
        <div
          v-if="tab === 'MEMBRES'"
          class="is-padding">
          <div :class="{'is-paddingless-bottom': canal.users && canal.accounts_in_sales.length}">
            <r-label
              :is-required="false"
              :label="'Membre(s) du canal'">
              <span class="tag has-text-weight-normal is-small is-primary is-margin-left-xsmall">{{ canal.accounts_in_sales.length }}</span>
            </r-label>
            <div
              class="column is-12 columns is-multiline"
              v-if="canal.accounts_in_sales && !canal.accounts_in_sales.length">
              <div class="notification is-warning is-radius-large is-padding-small">
                <p class="is-margin-right">
                  <i class="fal fa-comment-alt-exclamation fa-lg is-inline-block is-vcentered is-margin-right-xsmall"></i>
                  <span>Aucun membre dans le canal<br></span>
                </p>
              </div>
            </div>
            <a
              v-if="!canal.protected"
              @click.prevent.stop="openAddNewMember"
              class="columns is-vcentered is-gapless is-border is-padding-small has-link-grey">
              <div class="column">
                <div class="is-uppercase">
                  <avatar
                    :force-picto="true"
                    :use-picto-custom="'fal fa-user-plus'"
                    :is-avatar="false"
                    class="is-border is-medium"></avatar>
                  <span class="is-margin-left-small">Ajouter un Membre</span>
                </div>
              </div>
            </a>
          </div>
          <div
            class="is-padding-top"
            v-if="canal.accounts_in_sales && canal.accounts_in_sales.length">
            <div
              class="columns is-vcentered is-gapless is-border is-padding-small"
              v-for="(user, i) in accounts_in_sales"
              :key="user.pk">
              <div class="column columns is-gapless">
                <div class="column is-vcentered columns">
                  <avatar
                    :item="user"
                    :i="i"
                    class="is-medium"></avatar>
                  <div
                    class="is-margin-left-small">
                    <div class="title is-3">
                      <router-link :to="{name: 'CompanyVue', params: {id: user.pk}}">
                        <span class="is-size-4 has-text-weight-normal">{{ user.name }}</span>
                        <span class="has-text-grey is-size-5 has-text-weight-normal"> / {{ user.email }}</span>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div
                  class="column is-narrow has-text-right">
                  <button
                    class="button is-circle is-action"
                    @click="deleteUser(i)">
                    <i class="fal fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="tab === 'MANDATS'">
          <tabs
            :links="mandattabList"
            :current-tab="tabs"
            @changeView="tabs = $event"
            mode="emitter"
            class="is-border-bottom"></tabs>
          <div
            v-if="tabs === 'MANDATS_LIST_VUE'"
            class="">
            <table
              class="table is-fullwidth is-striped-v is-first-fixed-medium is-last-fixed-medium is-marginless has-cells-vcentered"
              v-if="all_mandats && all_mandats.length">
              <thead>
                <tr class="is-size-6">
                  <th></th>
                  <th>
                    Programme
                  </th>
                  <th>Date de début</th>
                  <th>Date de fin</th>
                  <th></th>
                  <th>Rémunération</th>
                </tr>
              </thead>
              <mandat-vue
                v-for="(a, i) in all_mandats"
                :key="i"
                :accesses="all_mandats"
                :allotments="allotmentList"
                :selected-access="selectedAccess"
                @selectedAccess="val => selectedAccess = val"
                :source="a"
                @afterdelete="afterDelete">
              </mandat-vue>
            </table>
            <pagination
              class="has-background-transparent"
              :loading="false"
              :current-page="currentMandatPage"
              :total-page="currentMandatTotalPage"
              @changePage="loadItems($event)" />
          </div>
          <div
            v-if="tabs === 'MANDATS_CREATE'">
            <mandat-form
              @aftercreate="afterCreate">
            </mandat-form>
          </div>
        </div>
        <div
          v-else-if="tab === 'INFO'"
          class="">
          <div
            class="is-padding">
            <div class="w50">
              <r-label
                label="Nom du canal"
                for="name"
                :is-required="false"></r-label>
              <v-input
                id="name"
                name="name"
                :model="newName"
                @input="val => newName = val"
                v-validate="'required|min:2'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Nom du canal">
              </v-input>
            </div>
          </div>
          <submit-sticky-buttons
            v-if="newName && newName !== canal.name"
            :cancel="cancel"
            @submit="save"
            :loading="submitLoading"></submit-sticky-buttons>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import { Quickview, Sort } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import { findIndex } from 'lodash'

const REMUNERATION_MODES = Object.freeze({
  PROGRAM: 'PROGRAM',
  CUSTOM: 'CUSTOM'
})

export default {
  name: 'ChannelVue',
  components: {
    MandatVue: () => import('@/components/mandat/MandatVue'),
    MandatForm: () => import('@/components/mandat/MandatForm')
  },
  mixins: [Quickview, Sort],
  props: {
    accessPk: {
      type: String
    },
    sourceAccess: {
      type: Object
    }
  },
  data () {
    return {
      submitLoading: false,
      newName: false,
      canal: null,
      accounts_in_sales: [],
      // service: 'MANDAT',
      loading: false,
      tab: 'MEMBRES',
      tabs: 'MANDATS_LIST_VUE',
      programsCurrent: null,
      programsChoosen: [],
      programsAccess: [],
      access: {},
      programLots: [],
      allotments: null,
      newAllotments: null,
      REMUNERATION_MODES,
      remunerationMode: null,
      program: {},
      all_mandats: null,
      total_mandats: null,
      allotmentList: null,
      selectedAccess: null
    }
  },
  computed: {
    ...mapState(['quickview', 'currentUser']),
    ...mapGetters(['isManager', 'isAdmin', 'isPromoteur', 'canAddUsers']),
    /**
      * pk of the canal
      * @return {string}
      */
    canalPk () {
      return this.$route.params.id
    },
    /**
      * tabs
      * @return {array}
      */
    canalTabLinks () {
      let tab = [{ label: 'Membres', link: 'MEMBRES' }, { label: 'Mandats', link: 'MANDATS' }, { label: 'Informations', link: 'INFO' }]
      return tab
    },
    mandattabList () {
      let tabs = []
      tabs.push({ label: `${this.total_mandats} Mandat(s) ouvert`, link: 'MANDATS_LIST_VUE' })
      if (this.isPromoteur && this.isAdmin) {
        tabs.push({ label: `Création mandat`, link: 'MANDATS_CREATE' })
      }
      return tabs
    }
  },
  watch: {
    async quickview ({ mode, params, results }) {
      if (results) {
        if (mode === 'USER_SELECTION') {
          let userToAdd = []
          for (let user of results.entities) {
            let { data } = await this.$api.axios.get('sales-channel')
            let channels = data.items
            let userUsed = []
            for (let channel of channels) {
              channel.accounts_in_sales.forEach(x => userUsed.push(x.pk))
            }
            // check user
            if (userUsed.includes(user.pk)) {
              this.$toasted.global.danger(`Le vendeur : ${user.name} est déjà présent dans un canal`)
            } else {
              userToAdd.push(user)
            }
          }
          if (userToAdd.length > 0) {
            this.addUsers(userToAdd)
            this.$toasted.global.success('Utilisateur(s) ajouté(s) au canal')
          }
        }
      }
    },
    'programsChoosen' (v) {
      this.programsCurrent = v
      this.allotments = null
    }
  },
  created () {
    this.init()
  },
  methods: {
    /**
      * init vue
      * get canal and set name
      */
    async init () {
      await this.getCanal()
      await this.getMandat()
      await this.getAllotment()
    },
    /**
      * cancel new name
      */
    cancel () {
      this.$set(this, 'newName', this.canal.name)
    },
    /**
      * get canal
      */
    async getCanal () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.CHANNELS, this.canalPk)
        this.canal = data
        this.loading = false
        this.accounts_in_sales = this.canal.accounts_in_sales
        this.$set(this, 'newName', this.canal.name)
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    /**
      * get mandat
      */
    async getMandat (page = 1, perPage = 50) {
      let payload = { sales_channel: this.canalPk, page, per_page: perPage }
      this.loading = true
      try {
        let { data } = await this.$api.get(this.$resources.MANDAT, payload)
        this.all_mandats = data.items
        this.total_mandats = data.total
        this.currentMandatPage = data.page
        this.currentMandatTotalPage = data.pages
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    loadItems (page) {
      this.getMandat(page)
    },
    /**
      * get allotment
      */
    async getAllotment () {
      let params = { sales_channel: this.canalPk }
      try {
        let { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
        this.allotmentList = data.all_allotment
      } catch (e) {
        console.log(e)
      }
    },
    /**
      * after post mandat
      */
    async afterCreate (mandatdata) {
      this.all_mandats.push(mandatdata)
      let params = { sales_channel: mandatdata.sales_channel.pk }
      let { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
      this.allotmentList = data.all_allotment
      this.tabs = 'MANDATS_LIST_VUE'
    },
    /**
      * after delete mandat
      */
    async afterDelete (mandatpk) {
      const i = findIndex(this.all_mandats, mandat => {
        return mandat.pk === mandatpk
      })
      if (i >= 0) {
        this.all_mandats.splice(i, 1)
      }
    },
    /**
      * save canal name
      */
    async save () {
      // let canal = Object.assign({}, this.canal)
      let canal = { 'pk': this.canal.pk, 'name': this.canal.name }
      if (this.newName) {
        canal.name = this.newName
      }
      this.submitLoading = true
      try {
        await this.$api.put(this.$resources.CHANNELS, this.canalPk, canal)
        this.submitLoading = false
        this.$toasted.global.success('Canal enregistré')
        this.getCanal()
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    },
    /**
      * prepar algolia params then
      * open new user quickview
      */
    openAddNewMember (type = 'multiple') {
      let params
      if (this.isAdmin && this.isPromoteur) {
        params = {
          searchKeys: ['ACCOUNT'],
          facets: {
            USER: [
              [`pk:-${this.currentUser.pk}`]
            ],
            ACCOUNT: []
          },
          selectType: type,
          mode: 'store'
        }
      } else {
        params = {
          facets: {
            USER: [
              [`pk:-${this.currentUser.pk}`]
            ]
          },
          selectType: type,
          mode: 'store'
        }
      }

      if (this.isManager) {
        params.facets.USER.push([`manager.pk:${this.currentUser.pk}`])
      }
      this.openUserSelectionQuickview(params)
    },
    /**
    * Add user in canal
    */
    async addUsers (allUser) {
      let canalAccounts = []
      this.canal.accounts_in_sales.forEach(user => { canalAccounts.push(user.pk) })
      for (let i of allUser) {
        canalAccounts.push(i.pk)
      }
      this.canal.accounts_in_sales = canalAccounts
      let canal = Object.assign({}, this.canal)
      this.submitLoading = true
      try {
        await this.$api.patch(this.$resources.CHANNELS, this.canalPk, canal)
        this.submitLoading = false
        // this.$toasted.global.success('Utilisateur ajouté au canal')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.getCanal()
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    },
    /**
      * Delete user in canal
      */
    async deleteUser (index) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false
      if (value) {
        let accountsPk = []
        this.canal.accounts_in_sales.forEach(user => { accountsPk.push(user.pk) })
        this.canal.accounts_in_sales = accountsPk
        let canal = Object.assign({}, this.canal)
        canal.accounts_in_sales.splice(index, 1)
        this.submitLoading = true
        try {
          await this.$api.patch(this.$resources.CHANNELS, this.canalPk, canal)
          this.submitLoading = false
          this.$toasted.global.success('Utilisateur supprimé du canal')
          this.getCanal()
        } catch (err) {
          console.log(err)
          this.submitLoading = false
        }
      }
    },
    /**
      * Confirm modal user
      */
    confirmDelete () {
      return this.$swal({
        title: 'Retirer utilisateur du canal',
        text: 'L\'utilisateur ne sera plus rattaché à ce canal. Les statistiques de canaux seront actualisées avec ce nouveau paramètre.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    /**
      * Delete canal
      */
    async removeCanal () {
      let value = await this.confirmDeleteCanal()
      if (value.dismiss) return false
      if (value) {
        this.loading = true
        try {
          await this.$api.delete(this.$resources.CHANNELS, this.canalPk)
          this.$toasted.global.success('Suppression du canal réussi')
          this.$router.push({ name: 'ChannelListVue' })
        } catch (e) {
          this.$toasted.global.danger('Erreur lors de la suppression')
        }
      }
    },
    /**
      * Confirm modal canal
      */
    async confirmDeleteCanal () {
      return this.$swal({
        title: 'Suppression du canal',
        text: 'Le canal sera supprimé définitivement',
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    }
  }
}
</script>
